import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { STORE_NAMES } from './constants';

export type CrossFilter = {
  filterName?: string;
  expression?: string;
};

export interface CrossFiltersState {
  crossFilters: Record<string, CrossFilter>;
  filterKeys: Array<string>;
  setCrossFilter: (filter: CrossFilter) => void;
  clearCrossFilters: () => void;
  setDecodedFilterKeys: (payload: { filterKeys: string[] }) => void;
}

export const initialFiltersState = {
  crossFilters: {},
  filterKeys: [],
};

export const useCrossFiltersStore = create<CrossFiltersState>()(
  devtools(
    (set) => ({
      ...initialFiltersState,
      setCrossFilter: (filter) =>
        set(
          (state) => {
            const { filterName, expression } = filter;
            return {
              crossFilters: {
                ...state.crossFilters,
                [filterName as string]: {
                  filterName: filterName,
                  expression,
                },
              },
            };
          },
          false,
          'crossFilters/setCrossFilter',
        ),
      clearCrossFilters: () =>
        set(
          () => ({
            crossFilters: {},
          }),
          false,
          'crossFilters/clearCrossFilters',
        ),
      setDecodedFilterKeys: (payload) =>
        set(
          () => {
            const { filterKeys } = payload;
            return {
              filterKeys: filterKeys,
            };
          },
          false,
          'crossFilters/setDecodedFilterKeys',
        ),
    }),
    {
      name: STORE_NAMES.CROSS_FILTERS,
      enabled: process.env.NODE_ENV === 'development',
    },
  ),
);
